import _ from "lodash";

// The antd form component expects this array type of name/value fields in order to use it as a
// controlled component (i.e. use Redux as the source of truth). Use this utility to convert a
// simple object map of fields to the form-compatible shape.
export const convertValuesToFormFields = <ValueType extends {}>(values: ValueType) =>
  _.map(values, (value, key) => ({ name: [key], value: _.isEqual(value, "") ? undefined : value }));
